module.exports = __webpack_public_path__ + "img/logo.7276abb2.png";